const LETTERS='CDEFGAB',SEMITONES=[0,2,4,5,7,9,11];
export function parseRequestedInterval(value){
 const m=String(value||'').trim().match(/^(MAJ|MIN|PER|AUG|DIM)\s+(\d+)(?:st|nd|rd|th|ve)?$/i);
 if(!m)return null;const quality=m[1].toUpperCase(),size=Number(m[2]);
 if(size<1||size>15)return null;
 const perfect=[0,3,4].includes((size-1)%7);
 if((quality==='PER'&&!perfect)||(['MAJ','MIN'].includes(quality)&&perfect))return null;
 return {quality,size};
}
export function intervalLabel({quality,size}){return `${({MIN:'min',DIM:'dim'})[quality] || quality} ${size===8?'8ve':size+(size%100>=11&&size%100<=13?'th':{1:'st',2:'nd',3:'rd'}[size%10]||'th')}`;}
export const INTERVAL_REQUEST_OPTIONS=Array.from({length:15},(_,i)=>i+1).flatMap(size=>{
 const perfect=[0,3,4].includes((size-1)%7);
 return (perfect?(size===1?['PER','AUG']:['PER','AUG','DIM']):['MAJ','MIN','AUG','DIM']).map(quality=>intervalLabel({quality,size}));
});
export function requestedIntervalRows(config){
 return Object.entries(config.givenNotes||{}).sort(([a],[b])=>Number(a)-Number(b)).flatMap(([slot,given])=>{
  const measure=Math.ceil(Number(slot)/(Number(config.slotsPerBar)||1));
  const text=config.notePrompts?.[slot]?.[0] ?? config.prompts?.find(p=>Number(p.measure)===measure)?.text;
  const request=parseRequestedInterval(text);if(!request)return [];
  const target=Array.isArray(config.inputSlots)?config.inputSlots.find(s=>Math.ceil(Number(s)/(Number(config.slotsPerBar)||1))===measure):slot;
  return [{slot,target:target==null?null:String(target),measure,given,request}];
 });
}
export function isIntervalConstruction(config){return config.inputMode==='placeNotes'&&requestedIntervalRows(config).length>0;}
export function intervalConstructionDirection(config){
 if(config.editorIntervalDirection)return config.editorIntervalDirection;
 // The introductory phrase may say 'on the staff below'; use the final direction.
 return JSON.stringify(config.prompt||{}).match(/\b(?:above|below)\b/gi)?.at(-1).toLowerCase()||'above';
}
export function transposeRequestedInterval(pitch,request,direction='above'){
 const m=String(pitch||'').replaceAll('♯','#').replaceAll('♭','b').replaceAll('♮','n').replaceAll('𝄪','##').replaceAll('𝄫','bb').replaceAll('x','##').match(/^([A-Ga-g])(#{1,2}|b{1,2}|n)?(-?\d+)$/);
 if(!m||!request)throw Error('Choose an interval and a given note with an octave.');
 const {quality,size}=request;const simple=(size-1)%7,perfect=[0,3,4].includes(simple);
 if((quality==='PER'&&!perfect)||(['MAJ','MIN'].includes(quality)&&perfect))throw Error('Choose a valid interval type and size.');
 const adjustment=quality==='MIN'?-1:quality==='AUG'?1:quality==='DIM'?(perfect?-1:-2):0;
 const distance=SEMITONES[simple]+12*Math.floor((size-1)/7)+adjustment;
 const sign=direction==='below'?-1:1,index=LETTERS.indexOf(m[1].toUpperCase()),octave=Number(m[3]);
 const sourceMidi=12*octave+SEMITONES[index]+[...(m[2]||'')].reduce((n,a)=>n+(a==='#'?1:a==='b'?-1:0),0);
 const targetDiatonic=octave*7+index+sign*(size-1),targetOctave=Math.floor(targetDiatonic/7),targetIndex=((targetDiatonic%7)+7)%7;
 if(targetOctave<0||targetOctave>8)throw Error('The answer is outside the supported octave range. Choose another interval or given note.');
 const accidental=sourceMidi+sign*distance-(12*targetOctave+SEMITONES[targetIndex]);
 if(Math.abs(accidental)>2)throw Error('This spelling requires more than a double accidental. Choose another interval or given note.');
 return LETTERS[targetIndex]+(accidental>0?'#'.repeat(accidental):'b'.repeat(-accidental))+targetOctave;
}
export function setRequestedInterval(config,slot,label){
 const request=parseRequestedInterval(label);if(!request)throw Error('Choose a supported interval.');
 config.notePrompts ||= {};config.notePrompts[slot]=[intervalLabel(request)];
 return syncIntervalConstruction(config);
}
export function syncIntervalConstruction(config){
 const rows=requestedIntervalRows(config),direction=intervalConstructionDirection(config);config.editorIntervalDirection=direction;config.editorIntervalConstruction=true;
 config.answers={};config.notePrompts ||= {};config.prompts ||= [];
 for(const {slot,target,measure,given,request} of rows){
  const label=intervalLabel(request);config.notePrompts[slot]=[label];
  let prompt=config.prompts.find(p=>Number(p.measure)===measure);
  if(prompt)prompt.text=label;else config.prompts.push({measure,text:label});
  if(target==null)continue;
  try{if(given.pitches?.length!==1)throw Error('Use one given note.');config.answers[target]=transposeRequestedInterval(given.pitches[0],request,direction);}catch{config.answers[target]='';}
 }
 function wording(value){
  if(typeof value==='string')return /^(?:above|below)$/i.test(value.trim())
   ? value.replace(/\b(?:above|below)\b/gi,direction)
   : value.replace(/\b(?:above|below)(?=\s+(?:(?:the|each|a)\s+)?given note)/gi,direction);
  if(Array.isArray(value))return value.map(wording);
  if(value&&typeof value==='object')return Object.fromEntries(Object.entries(value).map(([k,v])=>[k,wording(v)]));
  return value;
 }
 if(config.prompt)config.prompt=wording(config.prompt);
 config.rules={...config.rules,enforceOctave:true};
 return config;
}
